/* Preview presentation only. Server Liquid classifies products; this file never
   changes prices, cart contents, discounts, attributes or channel entitlements. */
(() => {
  if (customElements.get("pe-bf-cart-demo")) return;
  const instances = new Set();
  let timer, revision = 0, running = false, rerun = false;
  const schedule = () => {
    revision += 1;
    // Hide stale rule copy while Shopify recalculates the cart.
    instances.forEach(el => el.querySelector("[data-bf-state]")?.setAttribute("hidden", ""));
    clearTimeout(timer);
    timer = setTimeout(refresh, 160);
  };
  async function refresh() {
    if (!instances.size) return;
    if (running) { rerun = true; return; }
    running = true;
    const requested = revision;
    try {
      const root = window.Shopify?.routes?.root || "/";
      const url = new URL(root + "cart", location.origin);
      url.searchParams.set("section_id", "pe-bf-cart-state");
      url.searchParams.set("_pe_bf", Date.now().toString());
      const response = await fetch(url, { credentials: "same-origin", cache: "no-store" });
      if (!response.ok) throw new Error("BF state unavailable");
      const doc = new DOMParser().parseFromString(await response.text(), "text/html");
      const source = doc.querySelector("pe-bf-cart-demo");
      if (requested !== revision) return;
      instances.forEach(el => {
        if (!source) { el.replaceChildren(); return; }
        el.dataset.checkoutState = source.dataset.checkoutState;
        el.dataset.fanUnits = source.dataset.fanUnits;
        el.dataset.eligibleUnits = source.dataset.eligibleUnits;
        el.dataset.cartCount = source.dataset.cartCount;
        el.dataset.cartTotal = source.dataset.cartTotal;
        el.dataset.cartDiscount = source.dataset.cartDiscount;
        el.innerHTML = source.innerHTML;
        el.paint();
      });
    } catch (_) {
      // Fail closed: never leave a stale simulated benefit visible.
      instances.forEach(el => el.querySelector("[data-bf-state]")?.setAttribute("hidden", ""));
    } finally {
      running = false;
      if (rerun || requested !== revision) { rerun = false; schedule(); }
    }
  }
  customElements.define("pe-bf-cart-demo", class extends HTMLElement {
    connectedCallback() {
      instances.add(this);
      this.paint();
    }
    disconnectedCallback() {
      instances.delete(this);

    }
    paint() { /* Server-rendered copy only; no channel scenario selector. */ }

  });
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  }
  ["cart:updated", "cart:refresh", "pe:cart-updated", "pageshow", "focus"].forEach(name => window.addEventListener(name, schedule));
  document.addEventListener("change", event => {
    if (event.target.matches('cart-items input[name="updates[]"], cart-drawer input[name="updates[]"]')) schedule();
  });
  const drawer = document.querySelector("cart-drawer");
  if (drawer) {
    let opened = drawer.classList.contains("active");
    new MutationObserver(() => {
      const active = drawer.classList.contains("active");
      if (active && !opened) schedule();
      opened = active;
    }).observe(drawer, { attributes: true, attributeFilter: ["class"] });
  }
})();
